<template>
    <div class="footer-pp">
        <footer>
            <div class="container">
                <div class="row resume">
                    <div class="col-md-4">
                        <div class="logo">
                            <img :src="require(`@/assets/logo-ppp-dark2.jpg`)" alt="pp-logo" />

                            <!-- <img
                                :src="require(`@/assets/${getIsDarkTheme ? 'pp-logo-dark-theme.svg' : 'logo-ppp-dark.png'}`)"
                                alt="pp-logo"
                            /> -->
                        </div>

                        <!-- <div class="localizacao">
                            <i class="fas fa-map-marker-alt"></i>
                            <span>São Paulo - SP</span>
                        </div> -->
                    </div>

                    <!-- <div class="col-6 col-md-3 links">
                        <div class="topic">PLATAFORMA</div>

                        <ul>
                            <li>
                                <router-link :to="{ name: 'WhoWeArePage' }">Quem somos</router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'HowWeEmergedPage' }">Como surgimos</router-link>
                            </li>
                        </ul>
                    </div> -->

                    <div class="col-12 col-md-3 col-lg-4 links">
                        <!-- <div class="topic">EMPRESA</div> -->
                        <div>
                            <div class="topic">PLATAFORMA</div>

                            <ul>
                                <li>
                                    <router-link :to="{ name: 'WhoWeArePage' }">Quem somos</router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'HowWeEmergedPage' }">Como surgimos</router-link>
                                </li>

                                <li><router-link :to="{ name: 'ForWhomPage' }">Para quem é</router-link></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-5 col-lg-4 contacts">
                        <div>
                            <div class="logo-small-group" v-if="false">
                                <img
                                    :src="require(`../../../public/static/img/logo-facebook-small.svg`)"
                                    alt="logo-facebook-small"
                                />
                                <img
                                    :src="require(`../../../public/static/img/logo-instagram-small.svg`)"
                                    alt="logo-instagram-small"
                                />
                                <img
                                    :src="require(`../../../public/static/img/logo-linkedin-small.svg`)"
                                    alt="logo-linkedin-small"
                                />
                            </div>

                            <div class="contact">
                                <div>contato@potenciasperifericas.org.br</div>

                                <!-- <div>(48) 99999-9999</div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row rights">
                    <div class="col-md-5">@{{ new Date().getFullYear() }} Plataforma Potências Periféricas</div>

                    <div class="col-md-4 link">
                        <router-link :to="{ name: 'PrivacyPolicy' }">Política de Privacidade</router-link>
                    </div>

                    <div class="col-md-3 link">
                        <router-link :to="{ name: 'TermsUsePage' }">Termos de Uso</router-link>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'FooterPP',
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    }
}
</script>

<style scope src="./FooterPP-light-theme.css"></style>
<style scope src="./FooterPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/footer-pp/FooterPP.vue